import { render } from "./ImagensServicos.vue?vue&type=template&id=65dc6328"
import script from "./ImagensServicos.vue?vue&type=script&lang=js"
export * from "./ImagensServicos.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__